import { useState, useEffect } from "react";
const useDebounce = (value, debounceMs) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), debounceMs);
    return () => {
      window.clearTimeout(handle);
    };
  }, [value, debounceMs]);
  return debounced;
};
export {
  useDebounce
};
//# sourceMappingURL=useDebounce.js.map
